import React,{useState,useEffect} from 'react'
import {Box, TextField, FormControl, Tooltip, LinearProgress,
        Select, MenuItem, InputLabel, InputAdornment, IconButton, Input,
        Typography, FormLabel, RadioGroup, Radio, FormControlLabel} from '@material-ui/core' 
import DateFnsUtils from '@date-io/date-fns'; 
import esLocale from "date-fns/locale/es";
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Modal from '../generales/ModalCerrarActualiza';
import moment from 'moment'
import {llamaApiCargaToken,ErrorGeneral,llamadaApiCarga } from '../funciones/ClienteAxios';
import { toast } from 'react-toastify'; 
import SelectList from '../generales/SelectList';
const ModalNvoEdit = ({modalAbierto,setModalAbierto ,titulo,listPart,auxReg,getDatos,}) => {
    let history = useHistory();    
    const fechaMax = moment(new Date()).subtract(18,'years')  
    const nvl= localStorage.getItem('Tipo')?parseInt(localStorage.getItem('Tipo')):0;   
    const usuId =localStorage.getItem('UsuId') ;                    
    const [espera,setEspera]= useState(false);    
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [btnDeshabilitado,setBtnDeshabilitado]= useState(false)
    const [aviso, setAviso] = useState(false);  
    const[cambioEfectivo,serCambioEfectivo] = useState(false)        
    const[listTipo, setListTipo]= useState([]);  
    const[listMuni, setListMuni]= useState([]);  
    const[registro, setRegistro] = useState({Nombre:'', Tipo:"", Direccion:"", Municipio:"", Llave:0})  
    const{ Nombre,Tipo, Direccion, Municipio, Llave}=registro
    const source = axios.CancelToken.source();  
    let Dispvo =localStorage.getItem('Dispvo') ;    
    const auxDispV =Dispvo.length >= 12 ? Dispvo:'451224452121'  
    

    useEffect(() => {
      
        if (auxReg) 
        {   setRegistro({...registro, Nombre: auxReg.Nom, Llave: auxReg.Id})
        }
        //getListDto()
        //getListMuni()

    }, [])


              
    const getListDto = () => {
        const data = qs.stringify({
            Usuario: usuId, ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "perfil/v2/ios/evento/tipo";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {               
                let listNvo=[]
                auxiliar.forEach(element => {
                    listNvo.push({...element, cadena:`D${element.Nom} - ${element.ComNom}`})
                }); 
                setListTipo(auxiliar)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListMuni = () => {
        const data = qs.stringify({
            usuario:usuId, estado:15,  ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "lugar-municipio";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {               
               
                setListMuni(auxiliar)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const onChange = e =>
	{   
        let expNopermitida = new RegExp('[%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9$.@#_&-+()/:;!?,<>=]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
                && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
                || e.target.value===' '|| e.target.value==='') 
        {
            setRegistro({
                ...registro, 
                [e.target.name] : e.target.value//.toUpperCase()  
            })            
        }		
	};             

 
    const llamadaNvoPerfil = () => {                    
        const data = qs.stringify({
            Usuario:usuId,
            Llave:Llave,
            //Tipo:Tipo,
            //Muni:Municipio,
            Status:1,
            Descr:Nombre,
            Color:"#ffffff",
            //Direccion:Direccion,
            idDispositivo: auxDispV,
        });
        const url = "perfil/v1/apoyo/new";
        function respuesta(aux) {
            if (aux.length!==0)
            {   setBtnDeshabilitado(true)                                             
                const mensaje=auxReg ?"Se edito correctamente":"Se registro correctamente"
                setTipoAdvertencia("success")      
                setMensaje(mensaje);                
                setAviso(false);
                toast.success(mensaje,{
                    pauseOnFocusLoss: false,                    
                    toastId: `nvo-afil${1}`
                })          
                getDatos( )      
                setModalAbierto(false);            
               
            }
        }
        llamaApiCargaToken(data, url, respuesta,ErrorGeneral,setEspera,history,source);
    };

    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;                  
        if( campo===null || (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null) )
        ) 
        {   respuesta=true;                                   
            setMensaje('No se lleno el campo '+descripcion);
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }
        return(respuesta);
    }     


    const mandaAlerta=(mensaje,tipoAdvert)=>
    {
        setMensaje(mensaje);
        setTipoAdvertencia(tipoAdvert)  
        setAviso(true);      
    }
      
    function validaVariable(auxCampo,auxMensaje,auxTamanio) 
    {   let respuesta=false
        if ( !verificaNulos(auxCampo,auxMensaje) ) 
        {   if (auxCampo.length>=auxTamanio ) 
            {                
                respuesta=true                    
            }else
            {            
                mandaAlerta('Campo '+auxMensaje +' incompleto, debe escribir un '+ auxMensaje+' valido',"warning") 
            }
        }   
          
        return respuesta;
    }

 
 
    function guardarDatos(e)
    {   e.preventDefault()                
     
        if (//!verificaNulos(Municipio,"Municipio")   &&
            //!verificaNulos(Tipo,"Tipo")&& 
            validaVariable(Nombre,'Descripción',3)                      
            //&& validaVariable(Direccion,'Dirección',3)             
          )
        {           
            setMensaje('');                
            setAviso(false);                
            //  setBtnDeshabilitado(true)               
          
            llamadaNvoPerfil( )                               
        }                                  
    } 
      


 

    const onChangeSel=(e)=>{
        if (e!== null && e!== undefined) 
        {  setRegistro({...registro,[e.target.name] : e.target.value})
        }else
        {setRegistro({...registro,[e.target.name] : 0})
        } 
        
    }

 const slctMuni =                        
    <SelectList lista={listMuni} value={Municipio} onChange={onChangeSel} 
      etqVal={"Id"} etqId="Id" etqAlias={"Nom"} etiq={"Municipio"} nameEtq={"Municipio"}
      estilo={{minWidth:18+'rem' }} 
    /> 
 

    const DatosGenerales=(
        <div>            
         
        
            <TextField required id="Nombre-input" onChange={onChange} style={{paddingBottom:.5+'rem',width:20+'rem',marginRight:".5rem"}}
                label="Descripción" value={Nombre} name='Nombre'size="small" autoComplete='off' // defaultValue="Nombre"                
                //auxArrerror={arrError[3]} onBlur={()=>verifiNombre()}
            />
     
            {/* <br/>            
            <TextField required id="Direccion-input" onChange={onChange} style={{paddingBottom:.5+'rem',width:20+'rem',marginRight:".5rem"}}
                label="Dirección" value={Direccion} name='Direccion' size="small" autoComplete='off'                              
            /> */}
      
           
        </div> 
    )     

    const cerrarBorrar = () => {            
        setAviso(false);
        setModalAbierto(false);
        if (cambioEfectivo) 
        {   
        
        }
    };

    return (    
    <Modal
        titulo={titulo} modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
        mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
        aviso={aviso} btnDeshabilitado={btnDeshabilitado}
        setAviso={setAviso} tamanio={'md'} cargando={espera}     
        cerrarBorrar={cerrarBorrar}   
    >
        {DatosGenerales}
    </Modal>             
    )
}

export default ModalNvoEdit